var map = {
	"./Device": "bf82",
	"./Device.vue": "bf82",
	"./DeviceCollection": "8cb3",
	"./DeviceCollection.vue": "8cb3",
	"./DeviceViewModel": "b9c3",
	"./DeviceViewModel.ts": "b9c3",
	"./PortfolioGridItem": "047b",
	"./PortfolioGridItem.vue": "047b",
	"./PortfolioProject": "7d0c",
	"./PortfolioProject.ts": "7d0c",
	"./blocks/PortfolioAbout": "9ce6",
	"./blocks/PortfolioAbout.vue": "9ce6",
	"./blocks/PortfolioInterface": "5be5",
	"./blocks/PortfolioInterface.vue": "5be5",
	"./blocks/PortfolioProjectTeam": "3949",
	"./blocks/PortfolioProjectTeam.vue": "3949",
	"./blocks/PortfolioScreenMotto": "c1b4",
	"./blocks/PortfolioScreenMotto.vue": "c1b4",
	"./img/about_yota.png": "2a94",
	"./img/background-screen-6.svg": "798c",
	"./img/coral-1.png": "522a",
	"./img/coral-2.png": "9f62",
	"./img/coral-3.png": "5ecb",
	"./img/coral-4.png": "e0e2",
	"./img/coral-5.png": "6296",
	"./img/coralclub-1.png": "6150",
	"./img/coralclub-2.png": "3b61",
	"./img/coralclub-3.png": "8867",
	"./img/coralclub-4.png": "6707",
	"./img/coralclub-5.png": "b090",
	"./img/desktop.png": "14ae",
	"./img/droppshipp-1.png": "05c0",
	"./img/droppshipp-2.png": "6ace",
	"./img/droppshipp-3.png": "b2cd",
	"./img/droppshipp-4.png": "b589",
	"./img/droppshipp-5.png": "803a",
	"./img/droppshipp-6.png": "3836",
	"./img/droppshipp-7.png": "b019",
	"./img/dropshipp.jpg": "b8f0",
	"./img/smartphone.png": "9b13",
	"./img/tablet.png": "c578",
	"./img/wms-1.png": "62c9",
	"./img/wms-2.png": "ec10",
	"./img/wms-3.png": "11ec",
	"./img/wms-4.png": "e2fd",
	"./img/yota-1.png": "9e87",
	"./img/yota-2.png": "3018",
	"./img/yota-3.png": "0541",
	"./img/yota-5.png": "62c6",
	"./img/yota-6.png": "9b46",
	"./img/yota-ipad-1.png": "29f8",
	"./img/yota-ipad-2.png": "19d6",
	"./img/yota-vitrina-1.png": "83b4",
	"./img/yota-vitrina-2.png": "2915",
	"./img/yota-vitrina-3.png": "6216",
	"./img/yota-vitrina-4.png": "4a7a",
	"./img/yota-vitrina-5.png": "fabd",
	"./img/youta-4.png": "06ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b541";